import MobilePagination from '@components/catalog/pagination/mobile-pagination/mobile-pagination';
import { DEFAULT_BUYING_OFFERS_NUMBER_BUTTONS, DEFAULT_SELLING_OFFERS_TO_SHOW_CTA_TOP } from '@constants/negotiation';
import useWindowSize from '@hooks/use-window-size';
import Pagination from '@components/catalog/pagination/pagination';
import styles from '../selling-offers.module.scss';

interface SellingOffersProductsListPaginationProps {
  activePage: number;
  totalPages: number;
  totalCount: number;
  setActivePage: (page: number) => void;
}

const SellingOffersProductsListPagination: React.FC<SellingOffersProductsListPaginationProps> = ({
  activePage,
  totalPages = 0,
  setActivePage,
}) => {
  const { isWiderThanLg } = useWindowSize();

  return (
    <div className={styles.sellingOffers__productsListColumn__pagination}>
      {isWiderThanLg ? (
        <Pagination
          currentPage={activePage}
          pageCount={totalPages}
          onChange={(page) => setActivePage(Number(page))}
          buttonsToShow={DEFAULT_BUYING_OFFERS_NUMBER_BUTTONS}
        />
      ) : (
        <MobilePagination
          handleNext={() => setActivePage(activePage + 1)}
          handlePrevious={() => setActivePage(activePage - 1)}
          currentPage={activePage}
          pageCount={totalPages}
          showScrollTop={totalPages > DEFAULT_SELLING_OFFERS_TO_SHOW_CTA_TOP}
        />
      )}
    </div>
  );
};

export default SellingOffersProductsListPagination;
